import React from "react";
import style from "../styles.module.scss";
import { useSelector, useDispatch } from "react-redux";

function ParaType() {
    const mTable = useSelector((store) => store.masterTable);
    const dispatch = useDispatch();
    const rendering = !!mTable.proc && mTable.proc.match(/(USP|DSP)/);
    
    if(rendering) return (
        <div className={`${style.selectBox}`}>
            <ul>
                <li className={`${mTable.subtype === "IN" && style.active}`} onClick={() => dispatch({ type: "setMasterSubType", subtype: "IN" })} aria-hidden={true}>
                    Parameter In
                </li>
                <li className={`${mTable.subtype === "OUT" && style.active}`} onClick={() => dispatch({ type: "setMasterSubType", subtype: "OUT" })} aria-hidden={true}>
                    Parameter Out
                </li>
{/*                <li className={`${mTable.subtype === "SP" && style.active}`} onClick={() => dispatch({ type: "setMasterSubType", subtype: "SP" })} aria-hidden={true}>
                    Sample Point
                </li>*/}
                <li className={`${mTable.subtype === "OPT" && style.active}`} onClick={() => dispatch({ type: "setMasterSubType", subtype: "OPT" })} aria-hidden={true}>
                    QC Option
                </li>
            </ul>
        </div>
    );
    else return null;
}

export default ParaType;
